import React from 'react';
import { ZapIcon, ShieldIcon, SparklesIcon, TargetIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function PowerDarm() {
  const benefits = [{
    icon: <SparklesIcon className="w-8 h-8" data-id="element-264" />,
    title: 'Prebiotica',
    description: 'FructoOligosacchariden & Inuline die goede bacteriën voeden'
  }, {
    icon: <ShieldIcon className="w-8 h-8" data-id="element-265" />,
    title: 'Probiotica',
    description: 'Versterken de darmflora direct'
  }, {
    icon: <ZapIcon className="w-8 h-8" data-id="element-266" />,
    title: 'Immunostimulerende stoffen',
    description: 'Activeren het afweersysteem'
  }, {
    icon: <TargetIcon className="w-8 h-8" data-id="element-267" />,
    title: 'Natuurlijke kleefstof',
    description: 'Bindt en voert schadelijke bacteriën af'
  }];
  const idealFor = ['Na antibiotica behandeling', 'Bij het wisselen van voer', 'Bij darmklachten', 'Voor extra ondersteuning tijdens herstel'];
  return <section className="py-20 bg-gradient-to-b from-white to-orange-50" data-id="element-268">
      <div className="max-w-6xl mx-auto px-6" data-id="element-269">
        <div className="text-center mb-12" data-id="element-270">
          <div className="inline-block bg-[rgb(var(--color-secondary))] text-white px-6 py-2 rounded-full font-bold mb-4" data-id="element-271">
            Extra Ondersteuning
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-[rgb(var(--color-neutral-900))] mb-4" data-id="element-272">
            Geef de Darmen een Vliegende Start met Power-Darm
          </h2>
          <p className="text-xl text-[rgb(var(--color-neutral-800))] max-w-3xl mx-auto" data-id="element-273">
            Voor honden die extra ondersteuning nodig hebben
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-12" data-id="element-274">
          {/* Product Image */}
          <div className="relative" data-id="element-275">
            <div className="bg-gradient-to-br from-orange-100 to-amber-100 rounded-2xl p-12 text-center" data-id="element-276">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/nFFDzLBUCHH3hfbsF5Crke/1ad3f365-5736-4ec2-9e8d-5617d9cf282b.png" alt="Anifit Power-Darm supplement" className="w-48 h-48 sm:w-56 sm:h-56 object-contain mx-auto mb-4" data-id="element-277" />
              <h3 className="text-3xl font-bold text-[rgb(var(--color-neutral-900))] mb-2" data-id="element-278">
                Power-Darm
              </h3>
              <p className="text-lg text-[rgb(var(--color-neutral-800))]" data-id="element-279">
                De Turbo voor Darmherstel
              </p>
            </div>
            <div className="absolute -top-4 -right-4 bg-green-500 text-white px-4 py-2 rounded-full font-bold shadow-lg" data-id="element-280">
              Aanbevolen door experts
            </div>
          </div>

          {/* Benefits */}
          <div data-id="element-281">
            <h3 className="text-2xl font-bold text-[rgb(var(--color-neutral-900))] mb-6" data-id="element-282">
              Speciaal ontwikkeld voor extra ondersteuning
            </h3>

            <div className="space-y-4 mb-8" data-id="element-283">
              {benefits.map((benefit, index) => <div key={index} className="bg-white p-4 rounded-lg shadow-md border-l-4 border-[rgb(var(--color-secondary))]" data-id="element-284">
                  <div className="flex items-start gap-4" data-id="element-285">
                    <div className="text-[rgb(var(--color-secondary))] flex-shrink-0" data-id="element-286">
                      {benefit.icon}
                    </div>
                    <div data-id="element-287">
                      <h4 className="font-bold text-lg text-[rgb(var(--color-neutral-900))] mb-1" data-id="element-288">
                        {benefit.title}
                      </h4>
                      <p className="text-[rgb(var(--color-neutral-800))]" data-id="element-289">
                        {benefit.description}
                      </p>
                    </div>
                  </div>
                </div>)}
            </div>

            <div className="bg-gradient-to-r from-green-50 to-emerald-50 p-6 rounded-xl border border-green-200" data-id="element-290">
              <h4 className="font-bold text-lg text-[rgb(var(--color-neutral-900))] mb-3" data-id="element-291">
                Ideaal voor:
              </h4>
              <ul className="space-y-2" data-id="element-292">
                {idealFor.map((item, index) => <li key={index} className="flex items-center gap-2 text-[rgb(var(--color-neutral-800))]" data-id="element-293">
                    <span className="text-green-600 text-xl" data-id="element-294">✓</span>
                    {item}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-r from-[rgb(var(--color-primary))] to-emerald-700 text-white p-8 md:p-12 rounded-2xl text-center shadow-2xl" data-id="element-295">
          <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-296">
            Het Resultaat?
          </h3>
          <p className="text-xl mb-6 max-w-3xl mx-auto" data-id="element-297">
            Een snelle verbetering van de gezondheidstoestand en een stevige
            basis voor langdurige gezondheid.
          </p>
          <p className="text-lg mb-6 font-semibold" data-id="element-298">
            Krijg 10% korting met code "stresslessdogs"
          </p>
          <Button variant="secondary" size="large" href="https://www.anifit.com/content/dierenvoeding/shop/shop/article/398758/power-darm-100-g" data-id="element-299">
            Bestel Power-Darm Nu
          </Button>
        </div>
      </div>
    </section>;
}